import { Link } from 'react-router-dom';
import Icon from '../../components/AppIcon';
import UserLoginCard from './components/UserLoginCard';
import BusinessLoginCard from './components/BusinessLoginCard';
import AdminLoginCard from './components/AdminLoginCard';

const LoginSelection = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      {/* Header with back button */}
      <header className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <Link 
              to="/landing-page" 
              className="flex items-center gap-2 text-gray-600 hover:text-emerald-600 transition-colors"
            >
              <Icon name="ArrowLeft" size={20} />
              <span className="font-medium">Volver al Inicio</span>
            </Link>
            
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 bg-emerald-600 rounded-lg flex items-center justify-center">
                <Icon name="Zap" size={20} color="#FFFFFF" />
              </div>
              <span className="text-xl font-bold text-gray-900">BIZZNET</span>
            </div>
          </div>
        </div>
      </header>

      {/* Main content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12">
        {/* Breadcrumb */}
        <nav className="flex items-center gap-2 text-sm text-gray-600 mb-8">
          <Link to="/landing-page" className="hover:text-emerald-600">Inicio</Link>
          <Icon name="ChevronRight" size={16} />
          <span className="text-emerald-600 font-medium">Selección de Tipo de Cuenta</span>
        </nav>

        {/* Title section */}
        <div className="text-center mb-12">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
            Selecciona tu Tipo de Cuenta
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Elige cómo deseas iniciar sesión en BIZZNET. Cada tipo de cuenta tiene acceso a funcionalidades específicas.
          </p>
        </div>

        {/* Selection cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 max-w-7xl mx-auto mb-12">
          <UserLoginCard />
          <BusinessLoginCard />
          <AdminLoginCard />
        </div>

        {/* Registration link */}
        <div className="text-center">
          <p className="text-gray-600 mb-4">
            ¿Aún no tienes una cuenta?
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link 
              to="/user-registration" 
              className="inline-flex items-center gap-2 px-6 py-3 bg-white border-2 border-emerald-600 text-emerald-600 hover:bg-emerald-50 font-medium rounded-lg transition-colors duration-200"
            >
              <Icon name="UserPlus" size={18} />
              <span>Registrarse como Usuario</span>
            </Link>
            <Link 
              to="/business-registration" 
              className="inline-flex items-center gap-2 px-6 py-3 bg-white border-2 border-blue-600 text-blue-600 hover:bg-blue-50 font-medium rounded-lg transition-colors duration-200"
            >
              <Icon name="Building2" size={18} />
              <span>Registrarse como Empresa</span>
            </Link>
          </div>
        </div>

        {/* Help section */}
        <div className="mt-12 max-w-2xl mx-auto bg-blue-50 border border-blue-200 rounded-lg p-6">
          <div className="flex items-start gap-3">
            <div className="flex-shrink-0">
              <Icon name="Info" size={24} className="text-blue-600" />
            </div>
            <div>
              <h3 className="font-semibold text-blue-900 mb-2">¿Necesitas ayuda?</h3>
              <p className="text-sm text-blue-800 mb-3">
                Si tienes dudas sobre qué tipo de cuenta elegir o problemas para iniciar sesión, no dudes en contactarnos.
              </p>
              <div className="text-sm text-blue-900">
                <p className="font-medium mb-2">Contactar Soporte:</p>
                <div className="flex flex-col gap-1">
                  <a href="tel:+573152495959" className="text-blue-600 hover:text-blue-700 hover:underline">
                    +57 315 249 5959
                  </a>
                  <a href="mailto:bizznet.latam@gmail.com" className="text-blue-600 hover:text-blue-700 hover:underline">
                    bizznet.latam@gmail.com
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 mt-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="text-center text-sm text-gray-600">
            © 2025 BIZZNET. Todos los derechos reservados.
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LoginSelection;